import RoutesMap from '../../route_control/RouteControl'
import Logo from '../../assets/images/wrric_branding.png'
import { FaFacebookF, FaInstagram, FaLinkedinIn, FaPinterestP } from "react-icons/fa"
import { Button, Navbar, Nav } from 'react-bootstrap'
import AOS from 'aos'
import { useNavigate, Link } from 'react-router-dom'
import { KeyRound, Power, UserPen, Languages } from 'lucide-react'
import { useDispatch } from 'react-redux'
import { toggleChangePasswordModal } from '../../redux/slices/globalSlice'
import ChangePassword from '../../pages/user/change_password/ChangePassword'
import { Dropdown } from 'antd'
import img_nf from '../../assets/images/default.png'
import { useTranslation } from 'react-i18next'

export const HeaderImport = {
    RoutesMap,
    Logo,
    FaFacebookF,
    FaInstagram,
    FaLinkedinIn,
    FaPinterestP,
    Button,
    Navbar,
    Nav,
    Dropdown,
    AOS,
    useNavigate,
    Link,
    KeyRound,
    Power,
    UserPen,
    Languages,
    useDispatch,
    toggleChangePasswordModal,
    ChangePassword,
    img_nf,
    useTranslation,
}